import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
} from '@mui/material';
import { deleteApartment } from '../../services/apartmentService';
import SuccessMessageModal from '../Reusable/SuccessMessageModal';
import WarningMessageModal from '../Reusable/WarningMessageModal';

const DeleteApartmentModal = ({ isOpen, onClose, apartment, onApartmentDeleted }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [isWarningOpen, setIsWarningOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      await deleteApartment(apartment.apartment_id);
      setModalMessage('Apartamento eliminado correctamente.');
      setIsSuccessOpen(true);
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Error al eliminar el apartamento.';
      setModalMessage(errorMessage);
      setIsWarningOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSuccessClose = () => {
    setIsSuccessOpen(false);
    onApartmentDeleted();
    onClose();
  };

  return (
    <>
      <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Eliminar Apartamento</DialogTitle>
      <DialogContent>
        <Typography>
          ¿Estás seguro de que deseas eliminar el apartamento con matrícula: {apartment?.matricula}?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleSubmit} disabled={isLoading} color="error">
          {isLoading ? <CircularProgress size={24} /> : 'Eliminar'}
        </Button>
      </DialogActions>
    </Dialog>
    <SuccessMessageModal isOpen={isSuccessOpen} message={modalMessage} onClose={handleSuccessClose} />
    <WarningMessageModal isOpen={isWarningOpen} message={modalMessage} onClose={() => setIsWarningOpen(false)} />
    </>
  );
};

export default DeleteApartmentModal;
